/* eslint-disable */
import { DateTime } from 'luxon';

/* Get the current instant */
const now = DateTime.now();

export const activities = [
    {
        id          : '493190c9-5b61-4912-afe5-78c21f1044d7',
        image        : 'assets/images/avatars/jrl_photo.jpg',
        icon        : 'heroicons_solid:star',
        description : '<strong>John Levesque</strong> changed the status',
        date        : now.minus({minutes: 25}).toISO(), // 25 minutes ago
        extraContent: `<div class="m-1 py-0.5 px-2.5 rounded-full text-sm font-medium whitespace-nowrap text-green-800 bg-green-100"> Accepted </div>`,
    },
    {
        id           : '6e3e97e5-effc-4fb7-b730-52a151f0b641',
        image        : 'assets/images/avatars/jrl_photo.jpg',
        description  : '<strong>John Levesque</strong> added a <strong>note</strong>',
        date         : now.minus({minutes: 50}).toISO(), // 50 minutes ago
        linkedContent: 'Contact/John Levesque',
        link         : 'apps/file-manager/folders/bcec586e-0bd1-4019-8dd5-e9bac0a22dcd',
        useRouter    : true,
    },
    {
        id           : 'b91ccb58-b06c-413b-b389-87010e03a120',
        icon         : 'feather:share-2',
        description  : 'Item shared with <strong>Todd Levesque</strong>',
        date         : now.minus({hours: 3}).toISO(), // 3 hours ago
    },
    {
        id           : '541416c9-84a7-408a-8d74-27a43c38d797',
        icon         : 'feather:move',
        description  : '<strong>Roger Murray</strong> moved the item',
        date         : now.minus({hours: 5}).toISO(), // 5 hours ago
        linkedContent: 'Matters/Matter0113/brief',
        link         : '.',
        useRouter    : true,
    },
    {
        id          : 'ef7b95a7-8e8b-4616-9619-130d9533add9',
        icon         : 'feather:download', 
        description : '<strong>Roger Murray</strong> downloaded the item',
        date        : now.minus({hours: 7}).toISO(), // 7 hours ago
    },
    {
        id         : 'eb8aa470-635e-461d-88e1-23d9ea2a5665',
        image      : 'assets/images/avatars/female-04.jpg',
        description: '<strong>Sophie Stone</strong> added a note',
        linkedContent: 'Go to Notes',
        link         : '/apps/chat/5636c0ba-fa47-42ca-9160-27340583041e',
        useRouter    : true,
        date       : now.minus({hours: 9}).toISO(), // 9 hours ago
    },
    {
        id           : 'b85c2338-cc98-4140-bbf8-c226ce4e395e',
        icon         : 'mat_outline:file_copy',
        description  : '<strong>Sophie Stone</strong> created a copy',
        date         : now.minus({day: 1}).toISO(), // 1 day ago
        linkedContent: 'Copy of File',
        link         : '/apps/file-manager/folders/bcec586e-0bd1-4019-8dd5-e9bac0a22dcd',
        useRouter    : true,
    },
    {
        id           : 'fd0f01b4-f3de-4333-add5-cd86850279d3',
        icon         : 'feather:download',
        description  : '<strong>John Levesque</strong> downloaded the item',
        date         : now.minus({day: 1}).toISO(), // 1 day ago, 
    },
    {
        id           : 'fd0f01b4-f3de-4333-add5-cd86850279d1',
        icon         : 'feather:activity',
        description  : '<strong>John Levesque</strong> changed the status',
        extraContent: `<div class="m-1 py-0.5 px-2.5 rounded-full text-sm font-medium whitespace-nowrap text-blue-800 bg-blue-100"> 
                        Final
                        </div>`,

        date         : now.minus({day: 1}).toISO(), // 1 day ago, 
    },
    {
        id         : '8f8e1bf9-4661-4939-9e43-390957b60f44',
        icon       : 'heroicons_outline:star',
        description: '<strong>John Levesque</strong> has unstarred the item',
        date       :  now.minus({days: 1}).toISO(), // 3 days ago
    },
    {
        id         : '8f8e1bf9-4661-4939-9e43-390957b60f43',
        icon       : 'heroicons_outline:star',
        description: '<strong>John Levesque</strong> starred the item',
        date       :  now.minus({days: 1}).toISO(), // 3 days ago
    },
    {
        id           : 'fd0f01b4-f3de-4333-add5-cd86850279d1',
        icon         : 'feather:activity',
        description  : '<strong>Tina Harris</strong> changed the status',
        extraContent: `<div class="m-1 py-0.5 px-2.5 rounded-full text-sm font-medium whitespace-nowrap text-orange-800 bg-orange-100"> 
                        In Progress
                        </div>`,

        date         : now.minus({day: 1}).toISO(), // 1 day ago, 
    },
    {
        id           : '6e3e97e5-effc-4fb7-b730-52a151f0b642',
        image        : 'assets/images/avatars/jrl_photo.jpg',
        description  : '<strong>John Levesque</strong> added a note',
        date         : now.minus({minutes: 50}).toISO(), // 50 minutes ago
        linkedContent: 'Go to Notes',
        link         : '/apps/chat/5636c0ba-fa47-42ca-9160-27340583041e',
        useRouter    : true,
    },
    {
        id           : 'fd0f01b4-f3de-4333-add5-cd86850279f8',
        image        : 'assets/images/avatars/female-02.jpg',
        description  : '<strong>Tina Harris</strong> added a note',
        date         : now.minus({day: 1}).toISO(), // 1 day ago,
        linkedContent: 'Go to Notes',
        link         : '/apps/chat/5636c0ba-fa47-42ca-9160-27340583041e',
        useRouter    : true,
    },
    {
        id         : '8f8e1bf9-4661-4939-9e43-390957b60f42',
        icon       : 'heroicons_outline:pencil-square',
        description: '<strong>John Levesque</strong> renamed the item to \'New Name Here\'',
        date       : now.minus({days: 3}).toISO(), // 3 days ago
    },
    {
        id         : '30af917b-7a6a-45d1-822f-9e7ad7f8bf72',
        icon       : 'mat_outline:restore_from_trash',
        description: '<strong>John Levesque</strong> restored the item from trash',
        date       : now.minus({day: 4}).toISO(), // 4 days ago
    },
    {
        id         : '30af917b-7a6a-45d1-822f-9e7ad7f8bf71',
        icon       : 'heroicons_outline:trash',
        description: '<strong>John Levesque</strong> moved the item to the trash',
        date       : now.minus({day: 4}).toISO(), // 4 days ago
    },
    {
        id         : '30af917b-7a6a-45d1-822f-9e7ad7f8bf70',
        icon       : 'heroicons_solid:cloud-arrow-up',
        description: '<strong>John Levesque</strong> uploaded a new version of the file',
        date       : now.minus({day: 4}).toISO(), // 4 days ago
    },
    {
        id         : '30af917b-7a6a-45d1-822f-9e7ad7f8bf69',
        icon       : 'heroicons_solid:cloud-arrow-up',
        description: '<strong>John Levesque</strong> uploaded an item',
        date       : now.minus({day: 4}).toISO(), // 4 days ago
    },
];
